"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiEventFindQueryDto = void 0;
const class_validator_1 = require("class-validator");
const types_1 = require("../../../billing-api-charge/types");
const billing_api_supplier_changed_event_response_dto_1 = require("../../../billing-api-supplier/types/dtos/billing-api-supplier-changed-event-response.dto");
const transform_bool_1 = require("../../../../shared/pipes/transform-bool");
const transform_constructor_1 = __importDefault(require("../../../../shared/pipes/transform-constructor"));
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const class_transformer_1 = require("class-transformer");
let BillingApiEventFindQueryDto = class BillingApiEventFindQueryDto {};
__decorate([(0, class_validator_1.IsOptional)(), (0, transform_iso8601_date_1.default)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiEventFindQueryDto.prototype, "createdFrom", void 0);
__decorate([(0, class_validator_1.IsOptional)(), (0, transform_bool_1.TransformBool)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiEventFindQueryDto.prototype, "delivered", void 0);
__decorate([(0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), (0, transform_constructor_1.default)([types_1.BillingApiChargeEventResponseDto, billing_api_supplier_changed_event_response_dto_1.BillingApiSupplierChangedEventResponseDto]), __metadata("design:type", Object)], BillingApiEventFindQueryDto.prototype, "objectTypes", void 0);
__decorate([(0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiEventFindQueryDto.prototype, "workerId", void 0);
BillingApiEventFindQueryDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiEventFindQueryDto);
exports.BillingApiEventFindQueryDto = BillingApiEventFindQueryDto;
